import {useEffect} from 'react';

import {useParams} from 'react-router-dom';

import {Stack} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';
import {SubscriptionItemsManager} from '../components/SubscriptionItemsManager';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {useSubscription} from '../hooks/useSubscription';
import {useSubscriptionsSelection} from '../hooks/useSubscriptionsSelection';
import {useEditPageTools} from '../hooks/useEditPageTools';

export const EditPage = () => {

    const {id: componentId} = useParams();

    if (typeof componentId === 'undefined') {
        throw new Error('componentId is required parameter');
    }

    const {
        record: subscription,
        updateRecord,
    } = useSubscription(componentId);

    const {handleClearSelection} = useSubscriptionsSelection();

    const {
        mode,
        tools,
    } = useEditPageTools();


    useEffect(() => {
        handleClearSelection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    if (!subscription) {
        return <PlatformLoader message='Loading subscription...Please wait'/>;
    }


    return (
        <FormPageLayout
            title={subscription.customer?.name ? subscription.customer.name : subscription.id}
            pageNavigation={<EditPageNavigation component={subscription}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Stack gap='lg'>
                    <Profile record={subscription}/>
                    <SubscriptionItemsManager 
                        subscription={subscription} 
                        onUpdate={() => { /* noop */ }}
                    />
                </Stack>
                :
                <SimplePageContentWrapper>
                    <RecordForm record={subscription} handleSubmit={updateRecord}/>
                </SimplePageContentWrapper>
            }


        </FormPageLayout>
    );
};


